import React, { useState, useEffect, useRef } from "react";
import BtnPlayStore from "../BtnPlayStore";
import BtnAppStore from "../BtnAppStore";
import FooterLinks from "../FooterLinks";
import SocialMedias from "../FooterLinks/SocialMedias";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);
  const footerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 } // Triggers when 10% of the footer is visible
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
    };
  }, []);

  const LiensUtiles = [
    { label: t("header.Acceuil"), to: "/" },
    { label: t("header.Propos"), to: "/about" },
    { label: t("header.Blog"), to: "/blog" },
    { label: t("header.Plans"), to: "plan" },
  ];

  const Services = [
    { label: t("header.teleconsutation"), to: "/teleconsultation" },
    { label: t("header.urgences"), to: "urgences" },
    { label: t("header.examens"), to: "#" },
    { label: t("header.rdv"), to: "/rdv" },
    { label: t("header.Pharmacies"), to: "/pharmacies" },
  ];

  const Sécurité = [{ label: t("footer.securite"), to: "#" }];

  const Legal = [
    { label: t("footer.politique"), to: "#" },
    { label: t("footer.conditions"), to: "#" },
    { label: "FAQ", to: "/" },
  ];

  const Reseaux = [
    {
      to: "/",
      icon: (
        <img
          src="/assets/images/vecteurs/reseaux_sociaux/facebook-svgrepo-com.svg"
          alt="facebook"
          className="h-6"
        />
      ),
    },
    {
      to: "/",
      icon: (
        <img
          src="/assets/images/vecteurs/reseaux_sociaux/youtube-svgrepo-com.svg"
          alt="youtube"
          className="h-6"
        />
      ),
    },
    {
      to: "/",
      icon: (
        <img
          src="/assets/images/vecteurs/reseaux_sociaux/instagram-svgrepo-com.svg"
          alt="instagram"
          className="h-6"
        />
      ),
    },
    {
      to: "/",
      icon: (
        <img
          src="/assets/images/vecteurs/reseaux_sociaux/tiktok-logo-logo-svgrepo-com.svg"
          alt=" tiktok"
          className="h-6"
        />
      ),
    },
  ];

  return (
    <footer
      ref={footerRef}
      className={`transition-all duration-[2000ms] ease-in-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
      }`}
    >
      <div className="px-5 py-8 lg:px-16">
        <div className=" border-b-2 border-secondary-blue pb-6">
          <div
            className="bg-secondary-blue md:flex md:gap-6 lg:gap-4 lg:py-10 
      lg:px-24 md:text-left text-white rounded-lg p-6 mb-6
      text-center "
          >
            <div className="lg:pr-10">
              <h1 className="font-bold md:text-2xl lg:text-4xl text-xl mb-2">
                {t("footer.letterTitle")}
              </h1>
              <p className="mb-4">{t("footer.letterPara")}</p>
            </div>
            <div className="flex items-center justify-center w-10/12 mx-auto relative">
              <div className="w-full left-0 ">
                <input
                  type="text"
                  placeholder={t("footer.mail")}
                  className=" py-3 rounded-lg px-4 w-full outline-none  text-black"
                />
                <button
                  className="bg-primary-green  text-black py-3 absolute font-semibold 
            rounded-lg px-4  right-0"
                >
                  {t("footer.souscrire")}
                </button>
              </div>
            </div>
          </div>

          <div className="flex flex-col justify-center items-center">
            <img
              src="/assets/images/logos/logo original .svg"
              alt="logo"
              className="w-48 md:w-72 lg:w-96"
            />
            <h2 className="mb-2 font-bold md:text-2xl text-center">
              {t("footer.connecter")}
            </h2>
            <div className="flex  gap-4 ">
              <BtnPlayStore />

              <BtnAppStore />
            </div>
          </div>
        </div>

        <div className="lg:flex lg:justify-between">
          <div className="pt-4">
            {/* Utilisation du composant DropdownLinks sans icônes */}
            <FooterLinks
              links={LiensUtiles}
              buttonTitle={t("footer.liensUtiles")}
            />
          </div>
          <div className="pt-4">
            <FooterLinks links={Services} buttonTitle="Services" />
          </div>
          <div className="pt-4">
            <FooterLinks links={Sécurité} buttonTitle={t("footer.securite")} />
          </div>

          <div className="pt-4  ">
            <FooterLinks links={Legal} buttonTitle={t("footer.legal")} />
          </div>

          <div className="pt-4 pb-4">
            <SocialMedias
              links={Reseaux}
              buttonTitle={t("footer.reseauxSociaux")}
            />
          </div>
        </div>
      </div>
      <div className="bg-blue-primary flex justify-center  w-full py-2 text-white">
        <p>
          &copy; Copyright 2024{" "}
          <span className="text-primary-green font-bold"> Ekose RX </span> All
          Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
